import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { preparativosAPI } from '../../services/api';

// Async thunks
export const fetchTarjas = createAsyncThunk(
  'tarjas/fetchTarjas',
  async ({ propuestaId }, { rejectWithValue }) => {
    try {
      const response = await preparativosAPI.getTarjas({ propuestaId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const saveTarjas = createAsyncThunk(
  'tarjas/saveTarjas',
  async ({ propuestaId, tarjasData }, { rejectWithValue }) => {
    try {
      const response = await preparativosAPI.saveTarjas({ propuestaId, tarjasData });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTarjas = createAsyncThunk(
  'tarjas/deleteTarjas',
  async ({ propuestaId }, { rejectWithValue }) => {
    try {
      await preparativosAPI.deleteTarjas({ propuestaId });
      return propuestaId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const tarjasSlice = createSlice({
  name: 'tarjas',
  initialState: {
    tarjas: [],
    loading: false,
    error: null,
    currentPropuestaId: null
  },
  reducers: {
    clearTarjas: (state) => {
      state.tarjas = [];
      state.currentPropuestaId = null;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch tarjas
      .addCase(fetchTarjas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTarjas.fulfilled, (state, action) => {
        state.loading = false;
        state.tarjas = action.payload;
        state.currentPropuestaId = action.meta.arg.propuestaId;
      })
      .addCase(fetchTarjas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Save tarjas
      .addCase(saveTarjas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveTarjas.fulfilled, (state, action) => {
        state.loading = false;
        state.tarjas = action.payload;
      })
      .addCase(saveTarjas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete tarjas
      .addCase(deleteTarjas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTarjas.fulfilled, (state) => {
        state.loading = false;
        state.tarjas = [];
      })
      .addCase(deleteTarjas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearTarjas, setError } = tarjasSlice.actions;

// Selectors
export const selectTarjas = (state) => state.tarjas.tarjas;
export const selectTarjasLoading = (state) => state.tarjas.loading;
export const selectTarjasError = (state) => state.tarjas.error;
export const selectCurrentPropuestaId = (state) => state.tarjas.currentPropuestaId;

export default tarjasSlice.reducer;
